import React from "react";
import MainLayout from "../../layouts/MainLayout";

const MissionAndValues = () => {
  const values = [
    {
      title: "embrace diversity",
      text: "Give space for groups historically left out.",
      icon: require("../../assets/icons/embrace-diversity-icon.png"),
      background: require("../../assets/img/about/bg-embrace-diversity.png"),
    },
    {
      title: "be innovative",
      text: "Always look for ways to make it better.",
      icon: require("../../assets/icons/be-innovative-icon.png"),
    },
    {
      title: "develop collaboration",
      text: "Work with communities to develop together.",
      icon: require("../../assets/icons/develop-collaboration-icon.png"),
      background: require("../../assets/img/about/bg-develop.png"),
    },
    {
      title: "be sensitive",
      text: "Don’t forget the impact of past injustices.",
      icon: require("../../assets/icons/be-sensitive-icon.png"),
    },
    {
      title: "give back",
      text: "Always find ways to support communities.",
      icon: require("../../assets/icons/give-back-icon.png"),
      background: require("../../assets/img/about/bg-give-back.png"),
    },
  ];

  return (
    <MainLayout>
      <article className="bg-white">
        <div className="app-forager-international-news with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
          <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
            <h2 className="text-white text-4xl lg:text-6xl w-8/12 text-center">
              our mission and values
            </h2>
          </div>
        </div>
        <div
          className="mt-8 pr-3 pb-10 bg-page-mission-and-values bg-cover"
          style={{
            backgroundPosition: "30% 50%",
          }}
        >
          <div className="2xl:container mx-auto 2xl:px-0">
            <div className="">
            {values.map((card, index) => (
              <div
                key={card.title}
                className={`h-20 pr-8 xl:pl-24 pl-4 flex items-center text-white bg-left bg-cover bg-dark-denim rounded-r-full ${card.class}`}
                style={{
                  maxWidth: `${50 - index}rem`,
                  backgroundImage: `url(${card.background})`,
                }}
              >
                <div>
                  <h4 className="md:text-xl font-medium">{card.title}</h4>
                  <p className="text-sm md:text-lg">{card.text}</p>
                </div>
                <img src={card.icon} alt="" className="w-11 ml-auto" />
              </div>
            ))}
            </div>
          </div>
        </div>
        <div className="container mx-auto mt-5 md:mt-20 grid grid-cols-1 md:grid-cols-2 items-center sm:pb-32 gap-x-11">
          <div className="flex flex-col gap-x-5 px-4">
            <div className="mb-5">
              <h3 className="mb-4 text-2xl text-navy-blue font-medium">
                mission
              </h3>
              <p>
                Forager has a mission develop innovative solutions to challenges
                faced by the heritage sector. We create relationships with
                individual institutions and regional associations to have
                community-driven, collaborative programs that support all levels
                of the industry. Our goal is to understand the unique needs of
                this underserved community and work with partners around the
                world to build capacity for the sector as a whole.
              </p>
            </div>
            <div>
              <h3 className="mb-4 text-2xl text-navy-blue font-medium">
                vision
              </h3>
              <p className="pb-14 xl:pb-0">
                To create a heritage sector that is more self-reliant and
                sustainable in their operations and can meet their needs in a
                rapidly changing world without being solely reliant on
                government support to achieve their mandates.
              </p>
            </div>
          </div>
          <img
            src={require("../../assets/img/values/inspiring.jpg")}
            className="w-full sm:rounded-xl"
            alt="forager international mission and values"
          />
        </div>
      </article>
    </MainLayout>
  );
};
export default MissionAndValues;
